module.exports = __webpack_public_path__ + "img/03胡佳彬.122818d6.jpg";